// extracted by mini-css-extract-plugin
export default {"charts":"Charts_charts__Cz5Id","charts-title":"Charts_charts-title__XnUv8","charts-filters":"Charts_charts-filters__lO4NX","charts-filter":"Charts_charts-filter__DLOoS"};